// extracted by mini-css-extract-plugin
export default {"sampleBox":"styles-module--sampleBox--61f29","sampleTxt":"styles-module--sampleTxt--a3875"};